/**
 * Per-author visual identity for notes threads.
 *
 * Deliberately two-tone and on-brand rather than a per-author palette: the
 * current user's own notes read in the program green; everyone else's use a
 * neutral tone. The initials avatar still identifies each author by name, so
 * "mine vs. theirs" stays obvious without a wall of random colors.
 */

// Your own notes: program green. Everyone else's: neutral mint.
const MINE = { bg: 'var(--color-forest)', fg: '#ffffff', border: 'var(--color-forest)' };
const OTHER = { bg: 'var(--color-mint-dark)', fg: 'var(--color-forest)', border: 'var(--color-mint-dark)' };

/** Chip/border colors for a note, based on whether the viewer authored it. */
export function chipFor(isMine) {
  return isMine ? MINE : OTHER;
}

/** Up to two uppercase initials from a first/last name. */
export function initials(firstName, lastName) {
  const a = (firstName || '').trim();
  const b = (lastName || '').trim();
  const combined = `${a.charAt(0)}${b.charAt(0)}`.toUpperCase();
  return combined || '?';
}
